import { object, string } from 'yup';

export const originSchema = () => {
    return object().shape({
        code: string().required(),
        label: string().required(),
    });
};
